<template>
  <b-container class="feature-section mt-4">
    <b-row>
      <b-col md="3" v-for="(feature, index) in features" :key="index">
        <div class="feature-item">
          <img
            :src="feature.image"
            :alt="feature.title"
            class="feature-image"
          />
          <div class="feature-text">
            <h3 class="feature-title">{{ $t(feature.title) }}</h3>
            <p class="feature-description">{{ $t(feature.description) }}</p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "FeatureSection",
  props: {
    features: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.feature-section {
  background-color: #fff;
  /* padding: 20px 0; */

  border-radius: 10px;
  box-shadow: 0px 8px 40px 0px #00260314;
}

/* .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
} */

.feature-item {
  display: flex;
  align-items: center;
  text-align: left;
  flex: 1;
  padding: 0 10px;
}

.feature-image {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}

.feature-text {
  display: flex;
  flex-direction: column;
}

.feature-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.feature-description {
  font-size: 0.8rem;
  color: #999;
  margin: 5px 0 0;
  font-weight: 400;
}
/* Mobile styles */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 20px;
    padding: 15px;
  }

  .feature-item {
    flex-direction: column;
    text-align: center;
    padding: 10px 0;
  }

  .feature-image {
    margin: 0 0 10px 0;
  }

  .feature-title {
    font-size: 1.2rem;
  }

  .feature-description {
    font-size: 1rem;
  }
}
</style>
